import { schema } from "normalizr";

const AssetSchema = new schema.Entity("assets");

const AssetArraySchema = new schema.Array(AssetSchema);

export { AssetSchema, AssetArraySchema };